/**
 *  Publish Modal
 *  Author: Teemo
 *  CreatedAt: 2021-03-10
 */

import { message } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { SalesChannelContent } from '@/src//request/salesChannel/types';
import { Skeleton } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import SwitchCombination from '@/src/components/SwitchCombination/SwitchCombination';
// import { getTimezone } from '@/src/constrains/GlobalProvider/slice';
import {
  initializePublish,
  publishVersion,
} from '@/src/request/salesChannel/versionContent';
import {
  SalesChannelContentStatus,
  TimeRange,
} from '@/src/types/common/common';
import { get } from 'lodash';
// import { useSelector } from 'react-redux';
import { RangePicker } from 'src/components/';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';
const PublishModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    uuid,
    setModal,
    getVersionList,
    disabled,
    nonDefaultActiveTimePeriod,
  } = props;
  const liveStart = get(nonDefaultActiveTimePeriod, '0');
  const liveEnd = get(nonDefaultActiveTimePeriod, '1');

  const [defaultVersion, setDefaultVersion] = useState(false);
  const [beginDate, setBeginDate] = useState<string>('');
  const [beginTime, setBeginTime] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [endTime, setEndTime] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>('');
  const [occupiedRanges, setOccupiedRanges] = useState<TimeRange[]>([]);
  const [timeErr, setTimeErr] = useState<boolean>(false);
  const [iniData, setIniData] = useState<any>(null);
  const [timezoneGmt, setTimezoneGmt] = useState<string>('');
  // const timeZone = useSelector(getTimezone());
  const isNonDefaultAndLive =
    get(iniData, 'status') === SalesChannelContentStatus.Live &&
    !get(iniData, 'defaultVersion');

  const _bT = beginDate && beginTime ? `${beginDate} ${beginTime}` : null;
  const _eT = endDate && endTime ? `${endDate} ${endTime}` : null;

  const shouldPublishWarning = React.useMemo(() => {
    if (isNonDefaultAndLive) {
      return false;
    }
    if (liveStart) {
      if (_bT) {
        const isStartEarlierThanLive = moment(liveStart).isAfter(moment(_bT));
        if (isStartEarlierThanLive) {
          if (!_eT) {
            return true;
          } else {
            const isEndEarlierThanLive = moment(_eT).isSameOrAfter(
              moment(liveStart),
            );
            return isEndEarlierThanLive;
          }
        } else {
          if (!liveEnd) {
            return true;
          } else {
            const isStartLaterThanEnd = moment(liveEnd).isSameOrAfter(
              moment(_bT),
            );
            return isStartLaterThanEnd;
            // if (_bT) {
            //   const isStartLaterThanEnd = moment(_bT).isAfter(moment(liveEnd));
            //   return isStartLaterThanEnd;
            // }else{
            //   const now=moment();
            //    const isStartLaterThanEnd = moment(now).isAfter(moment(liveEnd));
            // }
          }
        }
      }
    } else {
    }
    return false;
  }, [
    isNonDefaultAndLive,
    nonDefaultActiveTimePeriod,
    beginDate,
    beginTime,
    endDate,
    endTime,
  ]);

  useEffect(() => {
    /** 初始化弹窗内容 */
    const initModal = () => {
      if (!loading) {
        setLoading(true);
      }
      initializePublish(uuid).then((res) => {
        const {
          salesChannelContent = {} as SalesChannelContent,
          occupiedRanges = [],
          timezoneGmt,
        } = res;
        const {
          defaultVersion = false,
          beginDate,
          beginTime,
          endDate,
          endTime,
        } = salesChannelContent;
        setIniData(salesChannelContent);
        setDefaultVersion(defaultVersion);
        setBeginDate(beginDate);
        setBeginTime(beginTime);
        setEndDate(endDate);
        setEndTime(endTime);
        setTimezoneGmt(timezoneGmt);
        setLoading(false);
        setOccupiedRanges(occupiedRanges);
      });
    };
    initModal();
  }, []);

  /**关闭弹窗 */
  const onCancel = () => {
    setModal(false);
  };

  /**判断时间区间 */
  const handleSetDefaultVersion = (value) => {
    setDefaultVersion(value);
    if (value === false) {
      if (occupiedRanges.length) {
        occupiedRanges.map((item) => {
          const {
            beginDate: beginDateRange = '',
            endDate: endDateRange = '',
            beginTime: beginTimeRange = '',
            endTime: endTimeRange = '',
          } = item;
          //判断初始时间是否合理
          const dateStart = moment(`${beginDate} ${beginTime}`);
          const dateEnd = moment(`${endDate} ${endTime}`);
          const rangeUsedStart = moment(`${beginDateRange} ${beginTimeRange}`);
          const rangeUsedEnd = moment(`${endDateRange} ${endTimeRange}`);

          if (dateStart <= rangeUsedStart && rangeUsedEnd <= dateEnd) {
            setTimeErr(true);
            setErrorText(
              getI18n('salesChannelContent.index.setDefaultVersionErrorText'),
            );
          }
          // Range intersects with other start ?
          if (dateStart <= rangeUsedStart && rangeUsedStart <= dateEnd) {
            setTimeErr(true);
            setErrorText(
              getI18n('salesChannelContent.index.setDefaultVersionErrorText'),
            );
          }
          // Range intersects with other end ?
          if (dateStart <= rangeUsedEnd && rangeUsedEnd <= dateEnd) {
            setTimeErr(true);
            setErrorText(
              getI18n('salesChannelContent.index.setDefaultVersionErrorText'),
            );
          }
        });
      }
    } else {
      setTimeErr(false);
      setErrorText('');
    }
  };
  /**提交数据，关闭弹窗 */
  const handleSubmit = () => {
    const data = {
      uuid,
      defaultVersion,
      specifiedBegin: beginDate && beginTime ? true : false,
      beginDate,
      beginTime,
      specifiedEnd: endDate && endTime ? true : false,
      endDate,
      endTime,
    };
    publishVersion(data)
      .then(() => {
        message.success('success');
        getVersionList();
        setModal(false);
      })
      .catch((error) => {
        console.error(`publishVersion error ${error}`);
      });
  };

  const handleChangeTime = (value) => {
    const { beginDate, beginTime, endDate, endTime } = value;
    setBeginDate(beginDate);
    setBeginTime(beginTime);
    setEndDate(endDate);
    setEndTime(endTime);
    setTimeErr(false);
    setErrorText('');
  };

  return loading ? (
    //骨架屏
    <Skeleton />
  ) : (
    <Row
      elements={[
        {
          child: (
            <React.Fragment>
              <div className={css.publishContain}>
                <SwitchCombination
                  value={defaultVersion}
                  title={getI18n(
                    'salesChannelContent.index.setasdefaultversion',
                  )}
                  onChange={(value) => handleSetDefaultVersion(value)}
                  popoverContent={getI18n(
                    'salesChannelContent.index.setasdefaultversiontip',
                  )}
                />
                {shouldPublishWarning && (
                  <div className={css.warning}>
                    {getI18n(
                      'salesChannelContent.index.setasdefaultversionwarning',
                    )}
                  </div>
                )}

                <ItemWrapper
                  title={`${getI18n(
                    'salesChannelContent.index.editTime',
                  )} (UTC  ${timezoneGmt})`}>
                  <RangePicker
                    disabled={disabled}
                    id={`time-picker-${Math.random()}`}
                    size='large'
                    value={{
                      beginDate: beginDate,
                      beginTime: beginTime,
                      endDate: endDate,
                      endTime: endTime,
                    }}
                    error={{
                      hasError: timeErr,
                      errorMsg: errorText,
                    }}
                    occupiedRanges={defaultVersion ? [] : occupiedRanges}
                    onChange={handleChangeTime}
                  />
                </ItemWrapper>
              </div>
              <ModalFooter
                onCancel={onCancel}
                hideOkButton={timeErr || !beginDate}
                okText={getI18n('general.publish')}
                onOk={handleSubmit}
              />
            </React.Fragment>
          ),
        },
      ]}
    />
  );
};

export default PublishModal;
